import { get } from "http";
import { Config } from "../../node_modules/@cvx/cal";

const calConfigLocal: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: "localStorage",
  instance: "https://login.microsoftonline.com/",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  clientId: "176ba817-e947-4b5d-96c5-652a383ee276",
  redirectUri: "https://localhost:44300",
  oidcScopes: ["openid", "profile", "email", "offline_access"],
  graphScopes: ["User.Read", "User.Read.All"]
}
const calConfigDev: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: "localStorage",
  instance: "https://login.microsoftonline.com/",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  clientId: "176ba817-e947-4b5d-96c5-652a383ee276",
  redirectUri: "https://accreq-dev.azure.chevron.com",
  oidcScopes: ["openid", "profile", "email", "User.Read", "offline_access"],
  graphScopes: [
    "GroupMember.Read.All",
    "Directory.Read.All",
    "Group.Read.All",
    "User.Read",
    "User.Read.All",
  ],
};

const calConfigTest: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: "localStorage",
  instance: "https://login.microsoftonline.com/",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  clientId: "176ba817-e947-4b5d-96c5-652a383ee276",
  redirectUri: "https://accreq-test.azure.chevron.com",
  oidcScopes: ["openid", "profile", "email", "User.Read", "offline_access"],
  graphScopes: [
    "GroupMember.Read.All",
    "Directory.Read.All",
    "Group.Read.All",
    "User.Read",
    "User.Read.All",
  ],
};

const calConfigProd: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: "localStorage",
  instance: "https://login.microsoftonline.com/",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
    clientId: "0c7dbf90-1197-4a4d-a738-06cb18f9bfe7",
  redirectUri: "https://accreq.azure.chevron.com",
  oidcScopes: ["openid", "profile", "email", "User.Read", "offline_access"],
  graphScopes: [
    "GroupMember.Read.All",
    "Directory.Read.All",
    "Group.Read.All",
    "User.Read",
    "User.Read.All",
  ],
};

export const environment = {
  calConfig: getCalConfig(),
  production: false,
  sendExternalEmail: false,
  msGraphUrl: "https://graph.microsoft.com/v1.0/",
  apiEndpoint: getApiEndpoint(),
  webUrl: getWebUrl(),
  APPLICATIONINSIGHTS_CONNECTION_STRING: getInstrumentationKey(),
};

function getCalConfig() {
  switch (process.env.REACT_APP_ENV) {
    case "prod":
      return calConfigProd;
    case "dev":
      return calConfigDev;
    case "test":
      return calConfigTest;
    case "local":
      return calConfigLocal;
    default:
      return calConfigLocal;
  }
}

function getApiEndpoint() {
  switch (process.env.REACT_APP_ENV) {
    case "dev":
          return "https://accreqapi-dev-cvx.azurewebsites.net/api";
    case "test":
          return "https://accreqapi-test-cvx.azurewebsites.net/api";
    case "prod":
          return "https://accreqapi-prod-cvx.azurewebsites.net/api";
    case "local":
      return "https://localhost:7160/api";
    default:
      return "http://localhost:7160/api";
  }
}

function getWebUrl() {
  switch (process.env.REACT_APP_ENV) {
    case "prod":
          return "https://accreq.azure.chevron.com";
    case "test":
      return "https://accreq-test.azure.chevron.com";
    case "dev":
      return "https://accreq-dev.azure.chevron.com";
    case "local":
      return "https://localhost:44300";
    default:
      return "https://localhost:44300";
  }
}

function getInstrumentationKey() {
  switch (process.env.REACT_APP_ENV) {
    case "prod":
      return "InstrumentationKey=004a2395-3946-4ccb-8065-f9259466f73b";
    case "test":
      return "InstrumentationKey=c2d76769-18b9-4127-a8e0-04d0edaf962a";
    case "dev":
      return "InstrumentationKey=50f026d5-cae6-4d57-9a04-c402cbde604b";
    case "local":
      return "InstrumentationKey=50f026d5-cae6-4d57-9a04-c402cbde604b";
    default:
      return "InstrumentationKey=50f026d5-cae6-4d57-9a04-c402cbde604b";
  }
}

